import React from "react"
import Proptypes from "prop-types"
import { Row, Col } from "reactstrap"

const ServiceCurrentSystem = props => {
  return (
    <div className="service-current-system">
      <div className="heading large-font">{props.titleMain}</div>
      <div className="description large-font">{props.descriptionMain}</div>
      <Row style={{ marginTop: "7vh" }}>
        <Col md="4" sm="12" className="each-col">
          <div className="heading">{props.title1}</div>
          <div className="description">{props.description1}</div>
        </Col>
        <Col md="4" sm="12" className="each-col">
          <div className="heading">{props.title2}</div>
          <div className="description">{props.description2}</div>
        </Col>
        <Col md="4" sm="12" className="each-col">
          <div className="heading">{props.title3}</div>
          <div className="description">{props.description3}</div>
        </Col>
      </Row>
    </div>
  )
}

ServiceCurrentSystem.prototype = {
  titleMain: Proptypes.any,
  descriptionMain: Proptypes.any,

  title1: Proptypes.any,
  description1: Proptypes.any,

  title2: Proptypes.any,
  description2: Proptypes.any,

  title3: Proptypes.any,
  description3: Proptypes.any,
}

export default ServiceCurrentSystem
